import _ from 'lodash';
import { createReducer } from 'reduxsauce';

import { types } from './actions';

const initialState = {
  list: {},
  loading: false,
  hasMore: true,
};

const startLoader = (state = initialState) => ({ ...state, loading: true });

const stopLoader = (state = initialState) => ({ ...state, loading: false });

const createSuccess = (state = initialState, action) => {
  const { list } = state;
  const { appKey } = action;
  return { ...state, list: { ...list, [appKey.id]: appKey }, loading: false };
};

const requestSuccess = (state = initialState, action) => {
  const { appKeys } = action;
  const { list } = state;
  return { ...state, list: { ...list, ..._.keyBy(appKeys, 'id') }, loading: false };
};

const updateSuccess = (state = initialState, action) => {
  const { appKeys } = action;
  const { list } = state;
  return { ...state, list: { ...list, ..._.keyBy(appKeys, 'id') }, loading: false };
};

const deleteSuccess = (state = initialState, action) => {
  const { id } = action;
  const { list } = state;
  return { ...state, list: _.omit(list, Array.isArray(id) ? id : [id]), loading: false };
};

export default createReducer(initialState, {
  [types.APP_KEYS_CREATE_REQUEST]: startLoader,
  [types.APP_KEYS_CREATE_SUCCESS]: createSuccess,

  [types.APP_KEYS_UPDATE_REQUEST]: startLoader,
  [types.APP_KEYS_UPDATE_SUCCESS]: updateSuccess,

  [types.APP_KEYS_REQUEST]: startLoader,
  [types.APP_KEYS_SUCCESS]: requestSuccess,
  [types.APP_KEYS_FAILURE]: stopLoader,

  [types.APP_KEYS_DELETE_REQUEST]: startLoader,
  [types.APP_KEYS_DELETE_SUCCESS]: deleteSuccess,
});
